// @flow strict

import * as React from "react";
import
{
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import Loader from "./Loader";
import { Link } from "react-router-dom";

function InfosEvent ( {
  idOrganizer,
  status,
  statusColor = "primary",
  banner,
  avatar,
  head,
  since,
  columns,
  updated = false,
  data,
} )
{
  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  const getStatusColor = ( status ) =>
  {
    if ( typeof status === "boolean" )
    {
      return status ? "success" : "danger";
    } else if ( typeof status === "number" )
    {
      return status === 1 ? "success" : status === 0 ? "danger" : "warning"; // Ajoutez d'autres cas si nécessaire
    } else
    {
      return status ? status : "secondary"; // Si `status` est une chaîne, utilisez-la telle quelle, sinon retournez une couleur par défaut
    }
  };
  const getStatusText = ( status ) =>
  {
    if ( typeof status === "boolean" )
    {
      return status ? "Activer" : "Désactiver";
    } else if ( typeof status === "number" )
    {
      return status === 1
        ? "Activer"
        : status === 0
          ? "Désactiver"
          : "En attente"; // Ajoutez d'autres cas si nécessaire
    } else
    {
      return status ? status : ""; // Si `status` est une chaîne, utilisez-la telle quelle, sinon retournez une couleur par défaut
    }
  };

  const computedStatusColor = statusColor
    ? statusColor
    : getStatusColor( status );

  return (
    <React.Fragment>
      <CardBody className="p-4">
        <div>
          <div className="w-100 position-relative flex-shrink-0 avatar-md mx-auto py-3"
            style={ {
              backgroundImage: `url(${ banner })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              marginBottom: "8%",
            } }>

            <div
              className={ `position-absolute top-10 end-0 translate-middle fw-bolder rounded btn-sm bg-${ computedStatusColor } shaddow-lg` }
            >
              { getStatusText( status ) }
            </div>

            <div
              className={ `translate-middle fw-bolder rounded shaddow-lg` }
              style={ {
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              } }
            >
              { avatar }
            </div>
          </div>
          {
            updated && data.organisation_id ===idOrganizer &&
            <div className="w-100 d-flex gap-2 justify-content-end p-2">
              <Link
                to={ `/evenements/add/${ data.id }` }
                className={ `btn btn-secondary btn-sm` }
              >
                Modifier
              </Link>
            </div>
          }

          <div className="mt-4 text-center">
            { head && <h5 className="mb-1">{ head }</h5> }
            { since && <p className="text-muted">Depuis { formatDate( since ) }</p> }
          </div>

          <div className="table-responsive">
            <Table className="table mb-0 table-borderless">
              {/* Liste des infos personnelles */ }
              <tbody>
                { columns.map( ( column, key ) =>
                {
                  return (
                    <tr key={ key }>
                      <th>
                        <span className="fw-bolder">{ column.Header }:</span>
                      </th>
                      <td>{ column.cell
                        ? column.cell( data ) // Utilise la fonction cell définie dans columnsInfo
                        : data[ column.accessor ] }</td>

                    </tr>
                  );
                } ) }
              </tbody>
              {/* Liste des infos personnelles */ }
            </Table>
          </div>
        </div>
      </CardBody>
    </React.Fragment>
  );
}

export default InfosEvent;
